/**
 * Shared "is this a photo" detection for upload flows.
 *
 * RAW camera formats (CR2, NEF, ARW, DNG, ...) frequently report a generic
 * or empty MIME type in the browser's File API, so extension is checked as
 * a fallback alongside the `image/*` MIME type.
 */
const IMAGE_EXTENSIONS =
  /\.(jpg|jpeg|png|gif|webp|heic|heif|tiff|tif|bmp|cr2|cr3|nef|arw|dng|orf|rw2|pef|srw|raf|raw)$/i

export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/') || IMAGE_EXTENSIONS.test(file.name)
}

/**
 * Filter a file list down to images (including RAW formats by extension).
 */
export function filterImageFiles(files: File[]): File[] {
  return files.filter(isImageFile)
}
